import React from 'react';
import { Text } from 'react-native';
import { withRouter } from "react-router-dom";

import { CardTextArrow, Spacing } from "../../components";
import { formatDate } from "../../constants/formatDate";

const PlayerDeliverableComponent= (props) => {

    const { title, description, status, createdAt, numberOfReviews, deliverableId } = props;

    let correctStatus = status;
    if (status === "in_review") correctStatus = "Em Revisão";
    if (status === "completed") correctStatus = "Completo";

    return (
        <CardTextArrow
            text={title}
            textStyle={{ color: 'black' }}
            arrowColor={'black'}
            showArrow={true}
            onPress={() => props.history.push(`/applications/userApplications/review?deliverableId=${deliverableId}`)}
            containerStyle={{ marginBottom: 12, backgroundColor: 'white', borderBottomWidth: 8, borderColor: '#1C8A44' }}
        >
            <Spacing height={6} />
            <Text style={{ fontSize: 16, color: 'black' }}>
                { description }
            </Text>
            <Spacing height={6} />

            <Text style={{ fontSize: 14, color: 'black' }}>
                { `Status: ${correctStatus}` }
            </Text>
            <Text style={{ fontSize: 14, color: 'black' }}>
                { `Número de Revisões: ${numberOfReviews}` }
            </Text>
            <Text style={{ fontSize: 14, color: 'black' }}>
                { `Enviado em: ${formatDate(createdAt)}` }
            </Text>

        </CardTextArrow>
    )
}

export default withRouter(PlayerDeliverableComponent);
